<script setup>
const props = defineProps({
  pgmode: String,
});

const emit = defineEmits(['qrOpen']);
</script>

<template>
  <div class="banner-box mb10" :class="{ rspage: pgmode === 'rs' }" style="margin-right: 12px">
    <img
      src="/src/assets/images_manse/banner02.png"
      alt=""
      style="cursor: pointer; margin-top: 46px"
      @click="emit('qrOpen')"
    />
  </div>
</template>
